import { createSelector } from '@reduxjs/toolkit'

import { selectMarketYoyGrowthExpectationState } from './selectMarketYoyGrowthExpectationState'

export const selectMarketYoyGrowthSaveError = createSelector(
  [selectMarketYoyGrowthExpectationState],
  (state) => state.saveError
)
